import { render, staticRenderFns } from "./ItserveTextarea.vue?vue&type=template&id=3f8a3e20&scoped=true&"
import script from "./ItserveTextarea.vue?vue&type=script&lang=js&"
export * from "./ItserveTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ItserveTextarea.vue?vue&type=style&index=0&id=3f8a3e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a3e20",
  null
  
)

export default component.exports